import React, { useState, useEffect, useContext } from "react";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import { Button, Card, Container, Typography, Box } from "@mui/material";

export default function NumberMemoryTest() {
  const [stage, setStage] = useState(1);
  const [currentNumber, setCurrentNumber] = useState("");
  const [userAnswer, setUserAnswer] = useState("");
  const [gameState, setGameState] = useState("START");
  const [timeLeft, setTimeLeft] = useState(3);
  const { userData } = useContext(UserDataContext);

  const generateNumber = (digits) => {
    let result = "";
    for (let i = 0; i < digits; i++) {
      result += Math.floor(Math.random() * 10).toString();
    }
    return result;
  };

  const startNextStage = (nextStage) => {
    const num = generateNumber(nextStage);
    setCurrentNumber(num);
    setUserAnswer("");
    setGameState("MEMORIZE");
    // Czas na zapamiętanie: 2s + 1s na każdą cyfrę
    setTimeLeft(2 + nextStage);
  };

  useEffect(() => {
    if (gameState !== "MEMORIZE") return;

    if (timeLeft === 0) {
      setGameState("ANSWER");
      return;
    }

    const timer = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft, gameState]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (userAnswer === currentNumber) {
      const next = stage + 1;
      setStage(next);
      startNextStage(next);
    } else {
      setGameState("RESULTS");
    }
  };

  // Reset gry do stanu początkowego
  const restartGame = () => {
    setStage(1);
    startNextStage(1);
  };

  return (
    <div>
      <VN userData={userData} />
      <Container sx={{ py: 5 }}>
        <Card
          elevation={1}
          sx={{
            backgroundColor: "#F8FAFC",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#FFFFFF",
              textAlign: "center",
              pt: 4,
              pb: 2,
              px: 3,
            }}
          >
            <h1 style={{ color: "#333" }}>Test Pamięci Numerycznej</h1>

            {gameState === "START" && (
              <div>
                <Typography
                  variant="h5"
                  component="h2"
                  sx={{ fontWeight: "bold", color: "text.primary", mb: 1 }}
                >
                  Z każdym poziomem liczba wydłuża się o 1 cyfrę. Zapamiętaj ją,
                  zanim zniknie!
                </Typography>
                <Button size="large" onClick={() => startNextStage(1)}>
                  Rozpocznij test
                </Button>
              </div>
            )}

            {gameState === "MEMORIZE" && (
              <div>
                <p style={{ color: "#888", fontSize: "14px" }}>
                  Poziom {stage}
                </p>
                <div
                  style={{
                    fontSize: "48px",
                    fontWeight: "bold",
                    letterSpacing: "5px",
                    margin: "20px 0",
                    color: "#0070f3",
                  }}
                >
                  {currentNumber}
                </div>
                <div
                  style={{
                    width: "100%",
                    backgroundColor: "#eee",
                    height: "8px",
                    borderRadius: "4px",
                  }}
                >
                  <div
                    style={{
                      width: `${(timeLeft / (2 + stage)) * 100}%`,
                      backgroundColor: "#0070f3",
                      height: "100%",
                      borderRadius: "4px",
                      transition: "width 1s linear",
                    }}
                  />
                </div>
                <p style={{ color: "#555", marginTop: "10px" }}>
                  Czas na zapamiętanie: {timeLeft}s
                </p>
              </div>
            )}

            {gameState === "ANSWER" && (
              <form onSubmit={handleSubmit}>
                <p style={{ color: "#888", fontSize: "14px" }}>
                  Poziom {stage}
                </p>
                <p style={{ fontSize: "18px", margin: "20px 0" }}>
                  Jaka to była liczba?
                </p>
                <input
                  type="text"
                  pattern="[0-9]*"
                  inputMode="numeric"
                  autoFocus
                  value={userAnswer}
                  onChange={(e) =>
                    setUserAnswer(e.target.value.replace(/\D/g, ""))
                  }
                  style={{
                    fontSize: "24px",
                    padding: "10px",
                    width: "100%",
                    boxSizing: "border-box",
                    textAlign: "center",
                    marginBottom: "20px",
                    borderRadius: "5px",
                    border: "2px solid #ccc",
                  }}
                />
                <Button type="submit" size="large">
                  Zatwierdź
                </Button>
              </form>
            )}

            {gameState === "RESULTS" && (
              <div>
                <h2 style={{ color: "#ff4d4f" }}>Koniec gry!</h2>
                <p style={{ fontSize: "20px" }}>
                  Twój poziom: <strong>{stage}</strong>
                </p>

                <div
                  style={{
                    margin: "20px 0",
                    textAlign: "left",
                    background: "#f5f5f5",
                    padding: "15px",
                    borderRadius: "5px",
                  }}
                >
                  <p style={{ margin: "5px 0" }}>
                    <strong>Właściwa liczba:</strong> {currentNumber}
                  </p>
                  <p style={{ margin: "5px 0" }}>
                    <strong>Twoja odpowiedź:</strong>{" "}
                    <span style={{ color: "#ff4d4f" }}>
                      {userAnswer || "(brak)"}
                    </span>
                  </p>
                </div>

                <Button onClick={restartGame} size="large">
                  Spróbuj ponownie
                </Button>
              </div>
            )}
          </Box>
        </Card>
      </Container>
    </div>
  );
}
